var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.2 21.3",
    style: {
      enableBackground: "new 0 0 19.2 21.3"
    },
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,12.3c0-0.4,0.3-0.8,0.8-0.8h3.3V8.3c0-0.4,0.3-0.8,0.8-0.8S12,7.9,12,8.3v3.2h3.3c0.4,0,0.8,0.3,0.8,0.8 s-0.3,0.8-0.8,0.8H12v3.2c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8v-3.2H7.2C6.8,13.1,6.5,12.7,6.5,12.3z M19.2,4.1v16.5 c0,0.4-0.3,0.8-0.8,0.8H4c-0.4,0-0.8-0.3-0.8-0.8V4.1c0-0.4,0.3-0.8,0.8-0.8h14.5C18.9,3.3,19.2,3.6,19.2,4.1z M17.7,4.8h-13v15h13 V4.8z M1.8,16.1H1.5V1.5h12.2v0.4c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V0.7c0-0.4-0.3-0.8-0.8-0.8H0.7C0.3,0,0,0.3,0,0.7v16.1 c0,0.4,0.3,0.8,0.8,0.8h1.1c0.4,0,0.8-0.3,0.8-0.8S2.2,16.1,1.8,16.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.5016b8bfb7f6b8c938f584d918356a62.svg";
export { ForwardRef as ReactComponent };